<template>
    <div class="loading loading-ellipsis" :class="cls">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
    export default {
        name: 'Loading',
        props: {
            color: String,
            size: String
        },
        computed: {
            cls(){
                switch(this.size){
                    case 'small': return {small: true};
                    default: return {};
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .loading-ellipsis
    {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;

        &.small
        {
            width: 40px;
            height: 40px;

            div
            {
                top: 17px;
                width: 7px;
                height: 7px;

                &:nth-child(1)
                {
                    left: 2px;
                    animation: loading-ellipsis1 0.6s infinite;
                }

                &:nth-child(2)
                {
                    left: 2px;
                    animation: loading-ellipsis2-small 0.6s infinite;
                }

                &:nth-child(3)
                {
                    left: 17px;
                    animation: loading-ellipsis2-small 0.6s infinite;
                }

                &:nth-child(4)
                {
                    left: 31px;
                    animation: loading-ellipsis3 0.6s infinite;
                }
            }
        }
    }

    .loading-ellipsis div
    {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: @base;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);

        &:nth-child(1)
        {
            left: 6px;
            animation: loading-ellipsis1 0.6s infinite;
        }

        &:nth-child(2)
        {
            left: 6px;
            animation: loading-ellipsis2 0.6s infinite;
        }

        &:nth-child(3)
        {
            left: 26px;
            animation: loading-ellipsis2 0.6s infinite;
        }

        &:nth-child(4)
        {
            left: 45px;
            animation: loading-ellipsis3 0.6s infinite;
        }
    }

    @keyframes loading-ellipsis1
    {
        0%
        {
            transform: scale(0);
        }

        100%
        {
            transform: scale(1);
        }
    }

    @keyframes loading-ellipsis3
    {
        0%
        {
            transform: scale(1);
        }
        100%
        {
            transform: scale(0);
        }
    }

    @keyframes loading-ellipsis2
    {
        0%
        {
            transform: translate(0, 0);
        }

        100%
        {
            transform: translate(19px, 0);
        }
    }

    @keyframes loading-ellipsis2-small
    {
        0%
        {
            transform: translate(0, 0);
        }

        100%
        {
            transform: translate(14px, 0);
        }
    }
</style>
